import { css, SerializedStyles } from '@emotion/react'
import { IStyles } from '../../context/Styles';

export const landingStyles = (styles: IStyles): SerializedStyles => css`
`;